import { ComplexValue, Value } from 'app/types-shared';
import { AccessItem, AccessMode } from 'app/components/access-panel/shared/types';
import { SingleOptionPanelSelectedValue } from 'app/components/access-panel/options-panel/types';

export const serializeValue = (item: AccessItem): Value[] => {

  if (!item || item.mode === AccessMode.role || !item.customData || !item.customData.selectedValues) {
    return [];
  }

  const values = item.customData.selectedValues as ComplexValue<number>[];

  return values.map(value => ({
    v: value.value
  }));
};

export const serializeValueOmitNotActive = (item: AccessItem): Value[] => {

  if (!item || item.mode === AccessMode.role || !item.customData || !item.customData.selectedValues) {
    return [];
  }

  const values = item.customData.selectedValues as SingleOptionPanelSelectedValue[];

  return values.filter(value => value.active).map(value => ({
    v: value.value
  }));
};

export const serializeKeyAndValue = (item: AccessItem, keyName: string, valueName: string): Value[] => {

  if (!item || item.mode === AccessMode.role || !item.customData || !item.customData.selectedValues) {
    return [];
  }

  const values = item.customData.selectedValues as { [key: number]: ComplexValue<number>[] };

  return Object.keys(values).reduce((m, keyValue) =>
    values[keyValue]
      ? [
        ...m,
        ...values[keyValue].map(value => ({
          [keyName]: { v: parseInt(keyValue, 10) },
          [valueName]: { v: value.value }
        }))
      ]
      : m, []);
};
